'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002497 from "./presto.-Presto-Router$$anon$97.js";
import * as $j_presto$002e$002dSign$002dDocument$002dPage$0024 from "./presto.-Sign-Document-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$96() {
  this.bp1 = null;
  this.boT = null;
  this.boU = false;
  this.bp2 = null;
  this.bp3 = false;
  this.bp6 = null;
  this.boZ = null;
  this.bp0 = false;
  this.boV = null;
  this.boW = false;
  this.boX = null;
  this.boY = false;
  this.bp4 = false;
  this.bp5 = false;
  this.bp1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bp6 = "SignDocumentPage";
}
export { $c_Lpresto_PrestoRouter$$anon$96 as $c_Lpresto_PrestoRouter$$anon$96 };
$p = $c_Lpresto_PrestoRouter$$anon$96.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$96;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$96() {
}
export { $h_Lpresto_PrestoRouter$$anon$96 as $h_Lpresto_PrestoRouter$$anon$96 };
$h_Lpresto_PrestoRouter$$anon$96.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bp1;
});
$p.M = (function() {
  if ((!this.boU)) {
    this.boT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.boU = true;
  }
  return this.boT;
});
$p.O = (function() {
  if ((!this.bp3)) {
    this.bp2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bp3 = true;
  }
  return this.bp2;
});
$p.E = (function() {
  return this.bp6;
});
$p.t = (function() {
  if ((!this.bp0)) {
    this.boZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bp0 = true;
  }
  return this.boZ;
});
$p.N = (function() {
  if ((!this.boW)) {
    this.boV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.boW = true;
  }
  return this.boV;
});
$p.Q = (function() {
  if ((!this.boY)) {
    this.boX = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002497.$c_Lpresto_PrestoRouter$$anon$97();
    this.boY = true;
  }
  return this.boX;
});
$p.v = (function() {
  if ((!this.bp5)) {
    this.bp4 = false;
    this.bp5 = true;
  }
  return this.bp4;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee597) => ((p) => \u03b4scrutinee597))($j_presto$002e$002dSign$002dDocument$002dPage$0024.$m_Lpresto_SignDocumentPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$96 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$96, "presto.PrestoRouter$$anon$96", ({
  Pf: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$96 as $d_Lpresto_PrestoRouter$$anon$96 };
//# sourceMappingURL=presto.-Presto-Router$$anon$96.js.map
